var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVenueBooking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2F2F2;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:none;stroke:#006DF0;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:#006DF0;}\n\t.st4{fill:none;stroke:#37CE93;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#37CE93;stroke-width:3;stroke-miterlimit:10;stroke-dasharray:27,4;}\n\t.st6{fill:none;stroke:#37CE93;stroke-width:3;stroke-miterlimit:10;}\n\t.st7{fill:none;stroke:#006DF0;stroke-width:3;stroke-miterlimit:10;}\n\t.st8{fill:#37CE93;}\n\t.st9{fill:none;stroke:#37CE93;stroke-width:3;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "71.73,47.28 95.02,90.78 4.98,90.78 29.7,45.18 50.41,45.18  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 69.66,
    y1: 50.05,
    x2: 72.77,
    y2: 50.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 27.93,
    y1: 50.05,
    x2: 53.65,
    y2: 50.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 20.33,
    y1: 63.61,
    x2: 80.5,
    y2: 63.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 10.72,
    y1: 80.19,
    x2: 89.35,
    y2: 80.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 50,
    y1: 45.18,
    x2: 50,
    y2: 90.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 62.08,
    cy: 56.45,
    rx: 8.98,
    ry: 3.38
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M70.39,24.83c0,4.87-3.95,8.82-8.82,8.82c-4.87,0-8.82-3.95-8.82-8.82c0-4.87,3.95-8.82,8.82-8.82 C66.44,16.01,70.39,19.95,70.39,24.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M46.84,34.2c-1.3-2.4-2.04-5.14-2.04-8.06c0-9.34,7.57-16.92,16.92-16.92s16.92,7.57,16.92,16.92 c0,2.91-0.74,5.66-2.04,8.05L61.58,54.2L46.84,34.2z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenueBooking);
export default __webpack_public_path__ + "static/media/Venue_Booking.d6cbf983c0c6d6248d59b88cf7752d7d.svg";
export { ForwardRef as ReactComponent };